import React from "react";
import PropTypes from "prop-types";

export function HorizontalCard({
    className = "",
    image = null,
    children,
    onClick,
    ...rest
}) {
    return (
        <article
            className={`ng-horizontal-card ${
                onClick ? "ng-horizontal-card--clickable" : ""
            } ${className}`}
            onClick={onClick}
            {...rest}
        >
            {image && <div className="ng-horizontal-card__image">{image}</div>}
            <div className="ng-horizontal-card__details">{children}</div>
            <style jsx>{`
                .ng-horizontal-card {
                    margin: -0.5em 0 0 -1em;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                }
                .ng-horizontal-card--clickable {
                    cursor: pointer;
                }
                .ng-horizontal-card__image {
                    display: inline-block;
                    vertical-align: middle;
                    margin: 0.5em 0 0 1em;
                    max-width: 5em;
                    max-height: 5em;
                    border-radius: 10px;
                    overflow: hidden;
                }
                .ng-horizontal-card__details {
                    display: inline-block;
                    vertical-align: middle;
                    margin: 0.5em 0 0 1em;

                    flex: 1 1 0px;
                    min-width: 8em;
                }
            `}</style>
        </article>
    );
}

HorizontalCard.propTypes = {
    className: PropTypes.string,
    image: PropTypes.node,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
};

HorizontalCard.defaultProps = {
    className: "",
    image: null,
    onClick: null,
};
